import {Component, Input, OnInit} from '@angular/core';
import {ActivityForEdit} from '../../../data/activityi-for-edit';

@Component({
  selector: 'app-activity-duration-edit-block',
  templateUrl: './activity-duration-edit-block.component.html',
  styleUrls: ['./activity-duration-edit-block.component.scss']
})
export class ActivityDurationEditBlockComponent implements OnInit {
  @Input()
  activity: ActivityForEdit
  @Input()
  displayComplexity: boolean
  @Input()
  wa: boolean

  constructor() {
  }

  ngOnInit(): void {
  }

}
